import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginPage.vue'
import HomePage from '../views/HomePage.vue'
import ApiDocLayout from '../views/ApiDocLayout.vue'
import ApiDocView from '@/views/ApiDoc.vue'
import DataDisplayView from '@/components/DataDisplay.vue';
import TestSnView from '@/components/TestSn.vue';
import BlackSnView from '@/components/BlackSn.vue';
import OutCodeView from '@/components/OutCode.vue';
import SnMycarInfoView from '@/components/SnMycarInfo.vue';
import VinListView from '@/components/VinList.vue';
import DataSwitchView from '@/components/DataSwitch.vue';
import VinIMMOView from '@/components/VinIMMO.vue';
import FileDownloadView from '@/components/FileDownload.vue';
import DeliverFunctionView from '@/components/DeliverFunction.vue';
import MazdaAllView from "@/components/MazdaAll.vue";
import FordConfigWorkspaceView from '@/components/ford/FordConfigWorkspace.vue';
import SgmMenuView from '@/components/SgmMenu.vue';
import { isAuthenticated } from '../api/users'
import store from '../store'
import { canAccessRoute } from '../utils/adminAccess.mjs'
const routes = [
  { path: '/login', name: 'LoginView', component: LoginView, },
  {
    path: '/', name: 'HomePage', component: HomePage, meta: { requiresAuth: true },
    children: [
      { path: '', name: 'DataDisplay', component: DataDisplayView },
      { path: 'fordconfig', name: 'FordConfig', component: FordConfigWorkspaceView, meta: { requiresSsvip: true } },
      { path: 'testsn', name: 'TestSn', component: TestSnView },
      { path: 'blacksn', name: 'BlackSn', component: BlackSnView },
      { path: 'outcode', name: 'OutCode', component: OutCodeView },
      { path: 'snmycarinfo', name: 'SnMycarInfo', component: SnMycarInfoView },
      { path: 'vinlist', name: 'VinList', component: VinListView },
      { path: 'dataswitch', name: 'DataSwitch', component: DataSwitchView },
      { path: 'vinimmo', name: 'VinIMMO', component: VinIMMOView },
      { path: 'filedownload', name: 'FileDownload', component: FileDownloadView },
      { path: 'deliverfunction', name: 'DeliverFunction', component: DeliverFunctionView },
      { path: "mazda", name: 'Mazda', component: MazdaAllView },
      { path: "sgm", name: 'SgmMenu', component: SgmMenuView, meta: { requiresSgm: true } },
      //{ path: "apidoc", name: 'ApiDoc', component: ApiDocView, meta: { aside: 'apidoc' } }
      // 其他子路由...  
    ]
  },
  {
    path: '/apidoc',
    component: ApiDocLayout,
    children: [
      {
        path: '',
        name: 'ApiDoc',
        component: ApiDocView
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 全局前置守卫  
// 认证缓存配置
let authCache = {
  value: null,
  time: 0,
  duration: 10 * 60 * 1000  // 10分钟
};

// 带缓存的认证检查
async function getCachedAuth() {
  const now = Date.now();

  if (authCache.value === true &&
      (now - authCache.time) < authCache.duration) {
    return true;
  }

  const result = await isAuthenticated();

  // 只缓存 true
  if (result === true) {
    authCache.value = true;
    authCache.time = now;
  }

  return result;
}

// 导出清除缓存的函数
export function clearAuthCache() {
  authCache.value = null;
  authCache.time = 0;
}

// 路由守卫（使用带缓存的函数）
router.beforeEach(async (to, from, next) => {
  const isAuth = await getCachedAuth();

  if (to.name === 'LoginView' && isAuth) {
    next({ name: 'HomePage', replace: true });
    return;
  }

  if (!isAuth && to.name !== 'LoginView') {
    next({ name: 'LoginView', replace: true });
    return;
  }

  if (isAuth && !canAccessRoute(store.state.userData, to)) {
    next({ name: 'DataDisplay', replace: true });
    return;
  }

  next();
});



export default router
